import React, { useRef, useState, useEffect } from 'react';
import { Shield } from 'lucide-react';

const VodafoneLogo = () => {
  const [imgError, setImgError] = useState(false);

  if (!imgError) {
    return (
      <img
        src="/vodafone-partner-business.png"
        alt="Vodafone Business Partner"
        onError={() => setImgError(true)}
        className="h-16 w-auto object-contain"
      />
    );
  }
  return (
    <div className="w-16 h-16 rounded-xl bg-gradient-to-br from-red-500 to-red-600 flex items-center justify-center shadow-md">
      <Shield size={28} className="text-white" />
    </div>
  );
};

const Partners = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setIsVisible(true); },
      { threshold: 0.1 }
    );
    const el = sectionRef.current;
    if (el) observer.observe(el);
    return () => { if (el) observer.unobserve(el); };
  }, []);

  return (
    <section
      ref={sectionRef}
      id="partners"
      className="py-14 md:py-20 bg-gray-50 border-y border-gray-100 relative overflow-hidden"
    >
      <div className="container mx-auto px-4 sm:px-6">
        <div
          className={`text-center mb-10 transition-all duration-700 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
          }`}
        >
          <span className="inline-block text-sm font-semibold uppercase tracking-widest text-red-600 mb-2">
            Partneři &amp; Certifikace
          </span>
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900">
            Certifikovaný Vodafone Business Partner
          </h2>
        </div>

        <div className="flex justify-center">
          <div
            className={`flex flex-col sm:flex-row items-center gap-6 p-8 rounded-2xl bg-white border border-gray-200 shadow-sm max-w-lg w-full transition-all duration-700 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
          >
            <VodafoneLogo />
            <div>
              <p className="text-lg font-bold text-gray-900 mb-1">Vodafone Business Partner</p>
              <p className="text-sm text-gray-500 mb-3">
                Jsme certifikovaný obchodní partner Vodafone pro segment B2B — mobilní služby,
                pevné připojení, IoT a pokročilá firemní řešení.
              </p>
              <div className="flex flex-wrap gap-2">
                {['Mobilní služby', 'Pevný internet', 'IoT'].map(tag => (
                  <span key={tag} className="text-xs bg-red-50 text-red-600 border border-red-100 rounded-full px-3 py-0.5 font-medium">
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>

        <p
          className={`text-center text-sm text-gray-400 mt-8 transition-all duration-700 delay-300 ${
            isVisible ? 'opacity-100' : 'opacity-0'
          }`}
        >
          Vyjednáme pro vás podmínky, které jako samotná firma nezískáte
        </p>
      </div>
    </section>
  );
};

export default Partners;
